import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Cookie from "js-cookie";
import Api from "utils/wApi/index";
import { BRANCH_LIST } from "utils/uiData";
import useCart from "store";
import dayjs from "dayjs";

import Cart from "layout/cart";
import {
	Grid,
	Container,
	Typography,
	Box,
	Stack,
	Button,
	CircularProgress,
} from "@mui/material";
import { Logo, CommonModal, SvgIconStyle } from "components";
import AdMenu from "components/ad/ad-menu";
import { ItemCard } from "components/unitComponent";

import { SET_PRICE_CURRENCY, ASC_SORT } from "utils/function";

import DefaultThumb from "assets/image/default_thumb.png";
import DefaultStandBy from "assets/image/default_standby.jpeg";
// ----------------------------------------------------------------------
// 메뉴 목록 페이지
export default function MenuPage() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const {
		language,
		standByImg,
		festival,
		branchLargeList,
		branchMidList,
		branchSmallList,
		activeBranchList,
		menuList,
		cart,

		setTimezone,
		setStandByImg,
		setFestival,
		setBranchLargeList,
		setBranchMidList,
		setBranchSmallList,
		setActiveBranchList,
		setMenuList,

		setActive,
		removeAllCart,
		setCountdown,
	} = useCart((state) => state);

	// 카테고리 없을시 모달 상태
	const [open, setOpen] = useState(false);
	// 메뉴 조회 로딩
	const [loading, setLoading] = useState(false);

	// 상품 목록 api
	const API_MENU_LIST = async (festivalId, branchSmallId) => {
		setLoading(true);
		const {
			data: { data: menuListData },
		} = await Api.getProductList(null, festivalId, {
			params: {
				idBranch: festivalId,
				idBranchMenu: branchSmallId,
				menuDate: Cookie.get("qs_kiosk_date") ?? dayjs().format("YYYY-MM-DD"),
			},
		});
		// 상품 순서변경
		const changeMenuList = ASC_SORT(menuListData, "orderDescending", "idMenu");

		setMenuList(changeMenuList);
		setLoading(false);
	};

	// ----- 대 카테고리 클릭 -----
	const clickBranchLarge = async (type) => {
		// 중-소카테고리 조회
		const {
			data: { data: midListData },
		} = await Api.getBranchMenuList(null, festival.id ?? festival.branchId, {
			params: { idBranch: festival.id ?? festival.branchId, type: type },
		});
		// 중카테고리 순서변경
		let changeMidList = [];
		if (midListData.length !== 0) {
			changeMidList = ASC_SORT(midListData, "priority", "idBranchMenu");
		}
		setBranchMidList(changeMidList);

		// 소카테고리 순서변경
		let changeSmallList = [];
		if (
			changeMidList.length !== 0 &&
			changeMidList[0].childBranchMenus.length !== 0
		) {
			changeSmallList = ASC_SORT(
				changeMidList[0].childBranchMenus,
				"priority",
				"idBranchMenu"
			);

			setBranchSmallList(changeSmallList);
			API_MENU_LIST(
				festival.id ?? festival.branchId,
				changeSmallList[0].idBranchMenu
			);
		} else {
			setBranchSmallList([]);
			setMenuList([]);
		}

		setActiveBranchList([
			type,
			changeMidList[0]?.idBranchMenu ? changeMidList[0].idBranchMenu : "",
			changeSmallList[0]?.idBranchMenu ? changeSmallList[0].idBranchMenu : "",
		]);
	};

	// ----- 중 카테고리 클릭 -----
	const clickBranchMid = async (branchMidId, idx) => {
		// 중-소카테고리 조회
		let changeSmallList = [];
		if (branchMidList[idx].childBranchMenus.length !== 0) {
			changeSmallList = ASC_SORT(
				branchMidList[idx].childBranchMenus,
				"priority",
				"idBranchMenu"
			);
			API_MENU_LIST(
				festival.id ?? festival.branchId,
				changeSmallList[0].idBranchMenu
			);
		}
		setBranchSmallList(changeSmallList);

		setActiveBranchList([
			activeBranchList[0],
			branchMidId,
			changeSmallList[0]?.idBranchMenu ? changeSmallList[0].idBranchMenu : "",
		]);
	};
	// ----- 소 카테고리 클릭 -----
	const clickBranchSmall = async (branchSmallId, idx) => {
		API_MENU_LIST(festival.id ?? festival.branchId, branchSmallId);

		setActiveBranchList([
			activeBranchList[0],
			activeBranchList[1],
			branchSmallId,
		]);
	};

	const INIT = async () => {
		if (!Cookie.get("Kiosk_ID")) return;

		try {
			// 대카테고리 조회
			const {
				data: { data: largeListData },
			} = await Api.getBranchList(null, festival.id ?? festival.branchId);

			// 대카테고리 순서변경
			const changeLargeList = largeListData.sort((a, b) => {
				let numA = parseInt(a.type.split("_")[2]);
				let numB = parseInt(b.type.split("_")[2]);
				return numA - numB; // 숫자 오름차순 정렬
			});
			// 중-소카테고리 조회
			const {
				data: { data: midListData },
			} = await Api.getBranchMenuList(null, festival.id ?? festival.branchId, {
				params: {
					idBranch: festival.id ?? festival.branchId,
					type: changeLargeList[0].type,
				},
			});
			// 중카테고리 순서변경
			const changeMidList = ASC_SORT(midListData, "priority", "idBranchMenu");
			const changeSmallList = ASC_SORT(
				changeMidList[0].childBranchMenus,
				"priority",
				"idBranchMenu"
			);

			// ===== SET =====
			Cookie.set("Festival_ID", festival.id ?? festival.branchId);

			setTimezone(festival.timezone ?? "Asia/Seoul");
			setFestival(festival);
			setBranchLargeList(changeLargeList);
			setBranchMidList(changeMidList);
			setBranchSmallList(changeSmallList);
			API_MENU_LIST(
				festival.id ?? festival.branchId,
				changeSmallList[0].idBranchMenu
			);

			setActiveBranchList([
				changeLargeList[0].type,
				changeMidList[0].idBranchMenu,
				changeSmallList[0].idBranchMenu,
			]);
		} catch (error) {
			// 안내 모달창 열기
			setOpen(true);
		}
	};

	useEffect(() => {
		branchLargeList.length === 0 && INIT();
	}, []);

	return (
		<Cart>
			<Box
				title="home"
				sx={{
					display: "flex",
					flexDirection: "column",
					position: "relative",
					px: 6,
					overflowY: "scroll",
					"&::-webkit-scrollbar ": {
						width: "10px",
						bgcolor: "grey.600",
					},
					"&::-webkit-scrollbar-thumb ": {
						width: "10px",
						borderRadius: 10,
						bgcolor: "grey.400",
					},
				}}
			>
				{/* 카테고리 */}
				<Stack
					gap={2}
					sx={{
						position: "fixed",
						zIndex: 1,
						bgcolor: "#fff",
						pb: 2,
						mt: "-1px",
						ml: "-1px",
					}}
				>
					{/* 대 카테고리 */}
					<Stack
						direction={"row"}
						gap={1}
						sx={{
							overflowX: "scroll",
							width: "calc(800px - 48px)",
						}}
					>
						{branchLargeList &&
							branchLargeList?.map((branchLarge) => (
								<Button
									key={branchLarge.type}
									variant="text"
									className={
										activeBranchList[0] === branchLarge.type ? "active" : ""
									}
									sx={{
										color: "black",
										px: 2,
										py: 1,
										borderRadius: 0,
										borderBottom: 3,
										borderColor: "#fff",
										textTransform: "none",
										"&.active, &:focus, &:hover": {
											borderColor: "#FF006E",
										},
									}}
									onClick={() => clickBranchLarge(branchLarge.type)}
								>
									<Box
										sx={{
											width: 30,
											height: 30,
											background: `center/contain no-repeat url(${branchLarge.defaultImage})`,
											mr: 1,
										}}
									/>
									<Typography variant="h4" sx={{ whiteSpace: "nowrap" }}>
										{branchLarge.typeName[language]}
									</Typography>
								</Button>
							))}
					</Stack>

					{/* 중 카테고리 */}
					<Stack
						direction={"row"}
						gap={1}
						sx={{
							overflowX: "scroll",
							width: "calc(800px - 48px)",
						}}
					>
						{branchMidList &&
							branchMidList?.map((branchMid, idx) => (
								<Button
									key={branchMid.idBranchMenu}
									variant="contained"
									className={
										activeBranchList[1] === branchMid.idBranchMenu
											? "active"
											: ""
									}
									sx={{
										px: 2,
										py: 1,
										color: "black",
										bgcolor: "#fff",
										border: 1,
										borderColor: "primary.main",
										textTransform: "none",
										"&.active, &:focus, &:hover": {
											color: "#fff",
											bgcolor: "primary.main",
										},
									}}
									onClick={() => clickBranchMid(branchMid.idBranchMenu, idx)}
								>
									<Typography variant="h5" sx={{ whiteSpace: "nowrap" }}>
										{branchMid.branchMenuName[language]}
									</Typography>
								</Button>
							))}
					</Stack>

					{/* 소 카테고리 */}
					<Stack
						direction={"row"}
						gap={1}
						sx={{
							overflowX: "scroll",
							width: "calc(800px - 48px)",
						}}
					>
						{branchSmallList &&
							branchSmallList?.map((branchSmall, idx) => (
								<Button
									key={branchSmall.idBranchMenu}
									className={
										activeBranchList[2] === branchSmall.idBranchMenu
											? "active"
											: ""
									}
									variant="contained"
									sx={{
										px: 2,
										py: 1,
										border: 1,
										color: "black",
										bgcolor: "#fff",
										borderColor: "#9E9E9E",
										bgcolor: "#fff",
										opacity: 0.7,
										textTransform: "none",
										"&::before": {
											width: 10,
											height: 10,
											borderRadius: 100,
											bgcolor: "primary.main",
											mr: 1.5,
										},
										"&.active, &:focus, &:hover": {
											bgcolor: "#F5F5F5",
											borderColor: "primary.main",
											opacity: 1,
											"&::before": { content: '""' },
										},
									}}
									onClick={() => {
										if (
											activeBranchList[2] === branchSmall.idBranchMenu &&
											loading
										)
											return;

										clickBranchSmall(branchSmall.idBranchMenu, idx);
									}}
								>
									<Typography variant="subtitle2" sx={{ whiteSpace: "nowrap" }}>
										{branchSmall.branchMenuName[language]}
									</Typography>
								</Button>
							))}
					</Stack>
				</Stack>
				{/* 카테고리 */}

				{/* 상품 리스트 */}
				<Grid
					container
					rowGap={3}
					columnGap={2}
					sx={{
						m: 0,
						pt: 25,
						pb: 30,
					}}
				>
					{loading ? (
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								width: "100%",
								height: 350,
							}}
						>
							<CircularProgress size={100} />
						</Box>
					) : menuList.length === 0 ? (
						<Typography
							variant="subtitle2"
							py={6}
							textAlign={"center"}
							width={"100%"}
						>
							{t("empty-item")}
						</Typography>
					) : (
						<>
							{/* 상품형 광고 */}
							<AdMenu />

							{menuList.map((menu) => (
								<Grid
									item
									key={menu.idMenu}
									sx={{ width: "calc(33% - 10px)" }}
									onClick={() => {
										if (
											menu?.soldOut ||
											menu?.normalInfo?.soldOutChk ||
											menu?.timeInfo?.soldOutChk
										)
											return;
										navigate(`/detail/${menu.idMenu}`);
									}}
								>
									<Box
										sx={{
											position: "relative",
											borderRadius: "4px",
											bgcolor: "grey.400",
											overflow: "hidden",
											width: "100%",
											height: "27.5vw",
											maxHeight: 219,
											mb: 1,
										}}
									>
										{/* 품절 */}
										{menu?.soldOut ||
										menu?.normalInfo?.soldOutChk ||
										menu?.timeInfo?.soldOutChk ? (
											<Box
												key={menu.idMenu}
												sx={{
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													width: "100%",
													height: "27.5vw",
													bgcolor: "#00000096",
													position: "absolute",
												}}
											>
												<Typography variant="h2" color={"white"}>
													SOLD OUT
												</Typography>
											</Box>
										) : null}
										<Box
											key={menu.idMenu}
											sx={{
												width: "100%",
												height: "100%",
												background: `center/cover no-repeat url(${
													menu?.thumbnailImage
														? menu?.thumbnailImage
														: DefaultThumb
												})`,
											}}
										/>
									</Box>
									<Typography
										variant="h5"
										sx={{
											textOverflow: "ellipsis",
											overflow: "hidden",
											WebkitLineClamp: 2,
											WebkitBoxOrient: "vertical",
											display: "-webkit-box",
										}}
									>
										{menu.menuName[language]}
									</Typography>
									<Typography
										variant="body2"
										sx={{
											textOverflow: "ellipsis",
											overflow: "hidden",
											WebkitLineClamp: 1,
											WebkitBoxOrient: "vertical",
											display: "-webkit-box",
											my: 0.5,
										}}
									>
										{menu.menuSubTitle[language]}
									</Typography>

									{menu?.soldOut ||
									menu?.normalInfo?.soldOutChk ||
									menu?.timeInfo?.soldOutChk ? (
										<Typography variant="h5" color={"grey.200"}>
											{/* 품절 */}
											{t("sold-out")}
										</Typography>
									) : (
										<Typography variant="h5" color={"primary.main"}>
											{`${SET_PRICE_CURRENCY(menu.price.krw, language)}${
												menu?.normalInfo?.optionMode === "TOP" ||
												menu?.normalInfo?.optionMode === "SELECT"
													? "~"
													: ""
											}`}
										</Typography>
									)}
								</Grid>
							))}
						</>
					)}
				</Grid>
				{/* 상품 리스트 */}
			</Box>
		</Cart>
	);
}
